import { OrderedMap, Map, fromJS } from 'immutable';
import * as constants from './constants';
import { LOGOUT } from '../loginSystem/constants';

export const createDefaultState = () =>
  fromJS({
    ppis: OrderedMap(),
    isFetching: false,
    fetchError: null,
    isFetchingGlobal: false,
    fetchGlobalError: null,
    isSaving: false,
    saveError: null,
    lastSavedPpiId: null,
    isPublishing: false,
    publishError: null,
    isUnpublishing: false,
    unpublishError: null,
    isCreatingDraft: false,
    createDraftError: null,
    isMarkingAsUptoDate: false,
    MarkAsUptoDateError: null,
    isImportingPpiUpdate: false,
    importPpiUpdateError: null,
    isImportingGlobalPpiUpdate: false,
    importGlobalPpiUpdateError: null,
    isdiscardingDraft: false,
    discardDraftError: null,
    marketPpis: Map(),
    fetchDeleteError: null,
    globalPpis: Map(),
    fetchingGlobalPpis: false,
    fetchGlobalPpisError: null,
    variantPpi: Map(),
    fetchingVariantPpi: false,
    fetchVariantPpiError: null,
    globalPublishedPpiIfs: Map(),
    ppiAvailabelData: Map(),
    updatePpis: Map(),
    updateGlobalPpis: Map(),
    openGlobalPpiDialog: null,
    globalPpiVariant: Map(),
    fetchGlobalPpiVariant: false,
    fetchGlobalPpiVariantError: null,
    relatedPpis: Map(),
    isFetchingPpis: false,
    ppiId: null,
    copyLocalPpis: Map(),
    isCopyLocalFetching: false,
    singlePpi: null
  });

// Transform list of objects to object with the ids as keys
const mergePpis = (state, ppis) =>
  state
    .get('ppis')
    .merge(
      ppis.reduce((map, ppi) => map.set(ppi.id, fromJS(ppi)), OrderedMap())
    );

const deletePpsis = (state, payload) => {
  let getPpsis = state.get('ppis');
  payload.forEach(id => {
    getPpsis = getPpsis.delete(id);
  });
  return getPpsis;
};

const mergeMarketPpis = (state, ppis) =>
  state
    .get('marketPpis')
    .merge(
      ppis.reduce((map, ppi) => map.set(ppi.id, fromJS(ppi)), OrderedMap())
    );

const removePpsi = state => {
  const ppsiId = state.get('lastSavedPpiId');
  const getPpsis = state.get('ppis');
  const result = (getPpsis.filter(i => i.id !== ppsiId), OrderedMap());
  return result;
};

export default function reducer(
  state = createDefaultState(),
  { type, payload }
) {
  switch (type) {
    case LOGOUT:
      return createDefaultState();

    case constants.FETCH_PPI:
      return state.set('isFetching', true).set('fetchError', null);
    case constants.FETCH_PPI_DONE:
      return state
        .set('ppis', mergePpis(state, [payload]))
        .set('singlePpi', fromJS(payload))
        .set('isFetching', false)
        .set('fetchError', null);
    case constants.FETCH_PPI_FAIL:
      return state.set('isFetching', false).set('fetchError', fromJS(payload));

    case constants.EMPTY_SINGLE_PPI:
      return state.set('singlePpi', null)

    case constants.FETCH_PPIS:
      if (payload && payload.type === 'updates') {
        return state.set('isFetchingRelatedPpis', true).set('fetchError', null);
      } else {
        return state.set('isFetching', true).set('fetchError', null);
      }

    case constants.FETCH_PPIS_DONE:
      if (payload && payload.type === 'updates') {
        // return state
        //   .set('ppis', mergePpis(state, payload.payload))
        //   .set('fetchError', null)
        //   .set('isFetchingRelatedPpis', false);
        return state
          .set('relatedPpis', fromJS(payload.payload))
          .set('isFetchingRelatedPpis', false)
          .set('fetchError', null);
      } else {
        return state
          .set('ppis', mergePpis(state, payload))
          .set('fetchError', null)
          .set('isFetching', false);
      }
    case constants.FETCH_PPIS_FAIL:
      return state.set('fetchError', fromJS(payload)).set('isFetching', false);

    case constants.FETCH_COPY_LOCAL_PPIS:
      return state.set('isCopyLocalFetching', true).set('fetchError', null);
    case constants.FETCH_COPY_LOCAL_PPIS_DONE:
      return state
        .set('copyLocalPpis', fromJS(payload))
        .set('isCopyLocalFetching', false)
        .set('fetchError', null);
    case constants.FETCH_COPY_LOCAL_PPIS_FAIL:
      return state
        .set('fetchError', fromJS(payload))
        .set('isCopyLocalFetching', false);

    case constants.FETCH_PPIS_GLOBAL:
      return state.set('isFetchingGlobal', true).set('fetchGlobalError', null);
    case constants.FETCH_PPIS_GLOBAL_DONE:
      return state
        .set('ppis', mergePpis(state, payload))
        .set('fetchGlobalError', null)
        .set('isFetchingGlobal', false);
    case constants.FETCH_PPIS_GLOBAL_FAIL:
      return state
        .set('fetchGlobalError', fromJS(payload))
        .set('isFetchingGlobal', false);

    case constants.CREATE_PPI:
      return state
        .set('isSaving', true)
        .set('saveError', null)
        .set('lastSavedPpiId', null);
    case constants.CREATE_PPI_DONE:
      return state
        .set('ppis', mergePpis(state, [payload]))
        .set('isSaving', false)
        .set('saveError', null)
        .set('lastSavedPpiId', payload.id);
    case constants.CREATE_PPI_FAIL:
      return state.set('isSaving', false).set('saveError', fromJS(payload));

    case constants.SAVE_PPI:
      return state
        .set('isSaving', true)
        .set('saveError', null)
        .set('lastSavedPpiId', null);
    case constants.SAVE_PPI_DONE:
      return state
        .set('ppis', mergePpis(state, [payload]))
        .set('isSaving', false)
        .set('saveError', null)
        .set('lastSavedPpiId', payload.id);
    case constants.SAVE_PPI_FAIL:
      return state.set('isSaving', false).set('saveError', fromJS(payload));

    case constants.PUBLISH_PPI:
      return state.set('isPublishing', true).set('publishError', null);
    case constants.PUBLISH_PPI_DONE:
      return state
        .set('ppis', mergePpis(state, [payload]))
        .set('isPublishing', false);
    case constants.PUBLISH_PPI_FAIL:
      return state
        .set('isPublishing', false)
        .set('publishError', fromJS(payload));

    case constants.UNPUBLISH_PPI:
      return state.set('isUnpublishing', true).set('unpublishError', null);
    case constants.UNPUBLISH_PPI_DONE:
      return state
        .set('isUnpublishing', false)
        .set('ppis', mergePpis(state, [payload]));
    case constants.UNPUBLISH_PPI_FAIL:
      return state
        .set('isUnpublishing', false)
        .set('unpublishError', fromJS(payload));

    case constants.MARKASUPTODATE_PPI:
      return state
        .set('isMarkingAsUptoDate', true)
        .set('MarkAsUptoDateError', null);
    case constants.MARKASUPTODATE_PPI_DONE:
      return state
        .set('isMarkingAsUptoDate', false)
        .set('ppis', mergePpis(state, [payload]));
    case constants.MARKASUPTODATE_PPI_FAIL:
      return state
        .set('isMarkingAsUptoDate', false)
        .set('MarkAsUptoDateError', fromJS(payload));

    case constants.CREATE_DRAFT_PPI:
      return state.set('isCreatingDraft', true).set('createDraftError', null);
    case constants.CREATE_DRAFT_PPI_DONE:
      return state
        .set('ppis', mergePpis(state, [payload]))
        .set('isCreatingDraft', false);
    case constants.CREATE_DRAFT_PPI_FAIL:
      return state
        .set('isCreatingDraft', false)
        .set('createDraftError', fromJS(payload));

    case constants.FETCH_NEW_PPI_AVAILABLE:
      return state.set('isFetching', true).set('publishError', null);
    case constants.FETCH_NEW_PPI_AVAILABLE_DONE:
      return state
        .set('ppiAvailabelData', fromJS(payload))
        .set('isFetching', false);
    case constants.FETCH_NEW_PPI_AVAILABLE_FAIL:
      return state
        .set('isFetching', false)
        .set('publishError', fromJS(payload));

    case constants.IMPORT_IFOOD_UPDATE_PPI:
      return state
        .set('isImportingPpiUpdate', true)
        .set('importPpiUpdateError', null);
    case constants.IMPORT_IFOOD_UPDATE_PPI_DONE:
      return state
        .set('isImportingPpiUpdate', false)
        .set('ppis', mergePpis(state, [payload]));
    case constants.IMPORT_IFOOD_UPDATE_PPI_FAIL:
      return state
        .set('isImportingPpiUpdate', false)
        .set('importPpiUpdateError', fromJS(payload));

    // PPI smart global update

    case constants.IMPORT_GLOBAL_UPDATE_PPI:
      return state
        .set('isImportingGlobalPpiUpdate', true)
        .set('importGlobalPpiUpdateError', null);
    case constants.IMPORT_GLOBAL_UPDATE_PPI_DONE:
      return state
        .set('isImportingGlobalPpiUpdate', false)
        .set('ppis', mergePpis(state, [payload]));
    case constants.IMPORT_GLOBAL_UPDATE_PPI_FAIL:
      return state
        .set('isImportingGlobalPpiUpdate', false)
        .set('importGlobalPpiUpdateError', fromJS(payload));

    // PPSI discard draft
    case constants.DISCARD_DRAFT_PPI:
      return state
        .set('isdiscardingDraft', true)
        .set('discardDraftError', null);
    case constants.DISCARD_DRAFT_PPI_DONE:
      return state
        .set('isdiscardingDraft', false)
        .set(
          'ppis',
          payload !== '' ? mergePpis(state, [payload]) : removePpsi(state)
        );
    case constants.DISCARD_DRAFT_PPI_FAIL:
      return state
        .set('isdiscardingDraft', false)
        .set('discardDraftError', fromJS(payload));

    case constants.FETCH_MARKET_PPIS:
      return state.set('isFetching', true).set('fetchError', null);
    case constants.FETCH_MARKET_PPIS_DONE:
      return state
        .set('marketPpis', fromJS(payload))
        .set('isFetching', false)
        .set('fetchError', null);
    case constants.FETCH_MARKET_PPIS_FAIL:
      return state.set('isFetching', false).set('fetchError', fromJS(payload));

    case constants.FETCH_GLOBAL_PPIS_WITH_ID:
      return state
        .set('fetchingGlobalPpis', true)
        .set('fetchGlobalPpisError', null);
    case constants.FETCH_GLOBAL_PPIS_WITH_ID_DONE:
      return state
        .set('globalPpis', fromJS(payload))
        .set('fetchingGlobalPpis', false)
        .set('fetchGlobalPpisError', null);
    case constants.FETCH_GLOBAL_PPIS_WITH_ID_FAIL:
      return state
        .set('fetchingGlobalPpis', false)
        .set('fetchGlobalPpisError', fromJS(payload));

    case constants.CREATE_PPI_VARIANT:
      return state
        .set('fetchingVariantPpi', true)
        .set('fetchVariantPpiError', null);
    case constants.CREATE_PPI_VARIANT_DONE:
      return state
        .set('variantPpi', fromJS(payload))
        .set('fetchingVariantPpi', false)
        .set('fetchVariantPpiError', null);
    case constants.CREATE_PPI_VARIANT_FAIL:
      return state
        .set('fetchingVariantPpi', false)
        .set('fetchVariantPpiError', fromJS(payload));

    case constants.FETCH_MARKET_USED_PPIS:
      return state.set('isFetching', true).set('fetchError', null);
    case constants.FETCH_MARKET_USED_PPIS_DONE:
      return state
        .set('marketPpis', fromJS(payload))
        .set('isFetching', false)
        .set('fetchError', null);
    case constants.FETCH_MARKET_USED_PPIS_FAIL:
      return state.set('isFetching', false).set('fetchError', fromJS(payload));

    case constants.FETCH_PPIS_UPDATE:
      return state.set('isFetching', true).set('fetchError', null);
    case constants.FETCH_PPIS_UPDATE_DONE:
      return state
        .set('ppis', fromJS(payload))
        .set('isFetching', false)
        .set('fetchError', null);
    case constants.FETCH_PPIS_UPDATE_FAIL:
      return state.set('isFetching', false).set('fetchError', fromJS(payload));

    case constants.FETCH_PPIS_GLOBAL_UPDATE:
      return state.set('isFetching', true).set('fetchError', null);
    case constants.FETCH_PPIS_GLOBAL_UPDATE_DONE:
      return state
        .set('ppis', fromJS(payload))
        .set('isFetching', false)
        .set('fetchError', null);
    case constants.FETCH_PPIS_GLOBAL_UPDATE_FAIL:
      return state.set('isFetching', false).set('fetchError', fromJS(payload));

    // Delete PPI
    case constants.DELETE_PPI:
      return state.set('isFetching', true).set('fetchDeleteError', null);
    case constants.DELETE_PPI_DONE:
      return state
        .set('ppis', deletePpsis(state, payload))
        .set('isFetching', false)
        .set('fetchDeleteError', null);
    case constants.DELETE_PPI_FAIL:
      return state
        .set('isFetching', false)
        .set('fetchDeleteError', fromJS(payload));

    // Fetch global PPi IFS Market for local market
    case constants.FETCH_GLOBAL_PPI_IFS:
      return state.set('isFetchingGlobal', true).set('fetchGlobalError', null);

    case constants.FETCH_GLOBAL_PPI_IFS_DONE:
      return state
        .set('isFetchingGlobal', false)
        .set('fetchGlobalError', null)
        .set('globalPublishedPpiIfs', fromJS(payload))
        .set('ppis', mergePpis(state, payload));

    case constants.FETCH_GLOBAL_PPI_IFS_FAIL:
      return state
        .set('isFetchingGlobal', false)
        .set('fetchGlobalError', fromJS(payload));
    //create global variant dialog
    case constants.GLOBAL_VARIANT_DIALOG:
      return state.set('openGlobalPpiDialog', fromJS(payload));

    //Fetch global PPi variant
    case constants.FETCH_GLOBAL_PPI_VARIANT:
      return state
        .set('fetchGlobalPpiVariant', true)
        .set('fetchGlobalPpiVariantError', null);

    case constants.FETCH_GLOBAL_PPI_VARIANT_DONE:
      return state
        .set('fetchGlobalPpiVariant', false)
        .set('fetchGlobalPpiVariantError', null)
        .set('globalPpiVariant', fromJS(payload));

    case constants.SET_PPI_ID:
      return state.set('ppiId', payload);

    case constants.FETCH_GLOBAL_PPI_VARIANT_FAIL:
      return state
        .set('fetchGlobalPpiVariant', false)
        .set('fetchGlobalPpiVariantError', fromJS(payload));
    default:
      return state;
  }
}
